module.exports = "<app-login></app-login>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/home/home.component.html
// module id = ./src/app/Components/home/home.component.html
// module chunks = main